import { render } from "./MonPouvoirAchat.vue?vue&type=template&id=696d4b01&ts=true"
import script from "./MonPouvoirAchat.vue?vue&type=script&lang=ts"
export * from "./MonPouvoirAchat.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__